import EmployeeContractTypeState from './EmployeeContractTypeContext/EmployeeContractTypeState'
import ContractorsState from './ContractorsContext/ContractorsState'
import ResourceTypeState from './ResourceTypeContext/ResourceTypeState'
import AccessHoursState from './AccessHoursContext/AccessHoursState'
import AccessUsersState from './AccessUsersContext/AccessUsersState'

const FiltersContext = ({ children }) => {
    return (
        <ResourceTypeState>
            <EmployeeContractTypeState>
                <ContractorsState>
                    <AccessHoursState>
                        <AccessUsersState>
                            {children}
                        </AccessUsersState>
                    </AccessHoursState>
                </ContractorsState>
            </EmployeeContractTypeState>
        </ResourceTypeState>
    )
}

export default FiltersContext